import { AppType } from "../shared/enums/app-type.enum";

export const environment = {
  production: true,
  appType: AppType.Direct,
  analyticsUrl: "/MaWebAnalytics/MaWebAnalytics/AnalyticsEntry",
  baseApiUrl: "/globapi",
  tokenApiUrl: "",
  ssoUrl: "",
  hostPrefix: "/directs",
  globtroterApp: 'app',
  sessionid: "",
  devToken:""
  
};
